import { RightOutlined } from '@ant-design/icons';
import { Tag } from 'antd';
import classNames from 'classnames';
import React from 'react';

import styles from './SectionRow.module.scss';

export type SectionRowProps = {
  labels: string[];
  tags?: string[];
  className?: string;
};

export const SectionRow: React.FC<SectionRowProps> = ({
  labels,
  tags = [],
  className = '',
}) => {
  return (
    <div className={classNames(styles.sectionRow, className)}>
      <div className={styles.labelsContainer}>
        {labels.map((label, index) => (
          <React.Fragment key={index}>
            <span
              className={classNames(styles.label, {
                [styles.primaryLabel]: index === 0,
                [styles.secondaryLabel]: index > 0,
              })}
            >
              {label}
            </span>
            {index < labels.length - 1 && (
              <RightOutlined className={styles.separator} />
            )}
          </React.Fragment>
        ))}
      </div>

      {tags.length > 0 && (
        <div className={styles.tagsContainer}>
          {tags.map((tag, index) => (
            <Tag key={index} className={styles.tag} icon={<RightOutlined />}>
              {tag}
            </Tag>
          ))}
        </div>
      )}
    </div>
  );
};
